import React from "react";
import { useTranslation } from "react-i18next";

import {
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Radio,
  Typography,
  makeStyles
} from "@material-ui/core";

import { DriveEta as DriveEtaIcon } from "@material-ui/icons";

import {
  UserAvatar
} from "../../index";

const useStyles = makeStyles(() => ({
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%"
  }
}));

const UserSelectEditorSelectList = ({
  users,
  isLoading,
  onDeselect,
  onSelect
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.center}>
        <CircularProgress />
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <div className={classes.center}>
        <Typography color="textSecondary">
          {t("webapp:common.title.noDriverFound")}
        </Typography>
      </div>
    );
  }

  return (
    <List>
      {users.map(({
        id,
        name,
        email,
        avatarUrl,
        isSelected
      }) => {
        const handleChange = () => {
          if (isSelected) {
            onDeselect();
          } else {
            onSelect(id);
          }
        };

        return (
          <ListItem button key={id} onClick={handleChange}>
            <ListItemAvatar>
              <UserAvatar size="medium" user={{ id, name, email, avatarUrl }} />
            </ListItemAvatar>
            <ListItemText
              primary={name}
              secondary={email}
            />
            <ListItemSecondaryAction>
              <Radio
                color="primary"
                checked={isSelected}
                edge="end"
                onClick={handleChange}
              />
            </ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );
};

export default UserSelectEditorSelectList;
